import React, { useMemo } from "react";
import { PlusIcon } from "@phosphor-icons/react";
import ModelsButton from "../ModelsButton";
import { calculateTotalDuration } from "../utils/trackingUtils";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isoWeek);

const TimeTableFooter = ({ entries, filteredEntries, tab, models, setModels, projects, sections, tasks, setEntries, automations, setAutomations, activeDay, onAddEntry }) => {
    const totalDuration = calculateTotalDuration(filteredEntries);

    const weeklyTotal = useMemo(() => {
        const currentWeek = activeDay.isoWeek();
        const currentYear = activeDay.isoWeekYear();

        const weekEntries = entries.filter((entry) => {
            const entryDate = dayjs(entry.date);
            return entryDate.isoWeek() === currentWeek && entryDate.isoWeekYear() === currentYear;
        });

        return calculateTotalDuration(weekEntries);
    }, [entries, activeDay]);

    return (
        <div className="entries-totals">
            <div className="new-entry">
                <button className="button-large new-line-button add" onClick={onAddEntry}>
                    <PlusIcon size={16} color="#3b61e1" weight="bold" />
                    Nouvelle saisie
                </button>
                <ModelsButton
                    models={models}
                    setModels={setModels}
                    projects={projects}
                    sections={sections}
                    tasks={tasks}
                    entries={entries}
                    setEntries={setEntries}
                    automations={automations}
                    setAutomations={setAutomations}
                    activeDay={activeDay}
                />
            </div>
            <div className="entries-count">
                <div>{filteredEntries.length} tâche{filteredEntries.length !== 1 ? 's' : ''}</div>
                <div>{totalDuration.toFixed(2)} h</div>
                <div>Total hebdo : {weeklyTotal.toFixed(2)} h</div>
            </div>
        </div>
    );
};

export default React.memo(TimeTableFooter);
